<template>
    <div class="row no-margin">
        <div class="col-sm-2  m-0 p-2 border rounded d-none">
                    
            <div role="presentation"  class="nav-item align-self-center text-center">                        
                <b-avatar class="" variant="light" rounded button size="200px" :src="company_logo"></b-avatar>
            </div>
        </div>

        <div class="col-sm-7 justify-content-center m-0 d-none">
            <div class="justify-content-center border rounded h-100">
                <div class="company-title border-top border-bottom border-top-0 rounded-top position-relative">
                    <h4 class="text-center font-weight-bold p-2 m-0">{{company_name}}</h4>   
                    <div class="pl-0 pr-2 float-left company-employee-count" @click="setCompany(company_id , 'employee')" style="height: 31px;"><span class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon class="" icon="people-fill"></b-icon></span><span class="text-center px-2 border d-inline-block h-100 employee-count-number" style="min-width: 51px;">{{companyemployees}}</span></div>      
                </div>
                <div class="row no-margin" style="min-height: 173px;">
                    <div class="col-md-6 my-3 pb-3 company-address border-right">
                        <p class="mb-0" v-html="companyaddress.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
                        <p class="mb-0">{{companycity}}</p>
                        <p class="mb-0">{{companyzip}}</p>
                    </div>
                    <div class="col-md-6 my-3 pb-3 company-address">
                        <p class="mb-0"><span class="info-head">Contact Person:</span> &nbsp;&nbsp;{{companycontactperson}}</p>
                        <p class="mb-0"><span class="info-head">Email:</span> &nbsp;&nbsp;{{companyemail}}</p>
                        <p class="mb-0"><span class="info-head">Contact No:</span> &nbsp;&nbsp;+880{{companyphone}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 justify-content-center m-0 px-0">
            <div v-if="activeclass != '' || activepayrunclass != '' || activechallanclass != '' || activeclassreturn != ''" class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a class="nav-item nav-link btn-primary" :class="this.activepayrunclass" id="nav-payrun-tab" v-bind:href="$api_url+'/payruns'">Pay Runs</a>
                <a class="nav-item nav-link btn-primary" :class="this.activeclass" id="nav-reports-tab" v-bind:href="$api_url+'/reports'">Reports</a>
                <a class="nav-item nav-link btn-primary" :class="this.activechallanclass" id="nav-settings-tab" v-bind:href="$api_url+'/challans'">Challans</a>
                <a class="nav-item nav-link btn-primary" :class="this.activeclassreturn" id="nav-settings-tab" v-bind:href="$api_url+'/payroll_report_return'">Regulatory Filing</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        
        mounted() {

        },
        data(){            
            
            return {                

                company_id:0,            
                company_name : '',
                company_logo : '',                
                companyaddress:'',              
                companyemployees:'',            
                companyphone:'',
                companyemail:'',
                companycontactperson:'',
                companycity:'',
                companyzip:'',
                currenturl:'',
                activeclass:'',
                activechallanclass:'',
                activepayrunclass:'',
                activeclassreturn:'',
                reportarray: [
                    "reports","payroll_monthly_report","payroll_tax_computation_sheet","income_tax_report","payroll_head_basis_yearly_report","salary_slips_report"
                ],
                reportpayrunchallanarray: [
                    "challans","payrun","reports","payroll_monthly_report","payroll_tax_computation_sheet","income_tax_report","payroll_head_basis_yearly_report","salary_slips_report","payroll_report_return","payroll_report_return108","payroll_report_return108a","payroll_report_return_statement_of_deduct"
                ],
                returnarray: [
                    "payroll_report_return","payroll_report_return108","payroll_report_return108a","payroll_report_return_statement_of_deduct"
                ],
                
            }
        },
        methods:{
            getCompanyPublicData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        
                    }
                }).then(function(response){
                    console.log(response);
                    this.company_id =  response.data.id;
                    this.company_name = response.data.name;
                    this.company_logo = this.$api_url+'/images/company/' + response.data.logo;
                    
                    this.companyaddress =  response.data.address;
                    this.companycity =  response.data.city;
                    this.companyzip =  response.data.zip;
                    this.companyemployees =  response.data.no_of_employees;
                    this.companyphone =  response.data.phone;
                    this.companyemail =  response.data.email;
                    this.companycontactperson =  response.data.contact_person;
                    
                }.bind(this));
            },
            setCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                                .then(function (response) 
                                {                                                                              
                                    window.location.href = this.$api_url+'/'+y;
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            

        },
        created: function(){
            let index;
            let currentpath = window.location.href;
            this.currenturl = currentpath.substring(currentpath.lastIndexOf('/') + 1);
            for (index = 0; index < this.reportarray.length; ++index) {
                if(currentpath.indexOf(this.reportarray[index]) > -1){
                    this.activeclass = 'active';
                }
            }
            if(this.returnarray.indexOf(this.currenturl) !== -1){
                this.activeclassreturn = 'active';
            }
            if(this.currenturl.indexOf("challans") !== -1){
                this.activechallanclass = 'active';
            }
            if(this.currenturl.indexOf("payrun") !== -1){
                this.activepayrunclass = 'active';
            }
            this.getCompanyPublicData();
        }
    }
</script>